import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ManageAlertsHeaderComponent } from '@notifications/pages/preferences/components/manage-alerts-header/manage-alerts-header.component';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [ManageAlertsHeaderComponent],
  imports: [CommonModule, IonicModule, SharedModule],
  exports: [ManageAlertsHeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotificationPreferencesModule {}
